var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Helper from '../riHelper';
import { TermNaviService } from './TermNaviService';
import Promise from 'bluebird';
import { TaxonomyHelper } from './TaxonomyHelper';
import { CacheLayer } from '@/central';
import { BaseService } from './BaseService';
var NewsService = (function (_super) {
    __extends(NewsService, _super);
    function NewsService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NewsService.prototype, "viewFields", {
        get: function () {
            return [NewsService.fieldImage];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "fieldTitle", {
        get: function () {
            return 'Title';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "fieldTeaser", {
        get: function () {
            return 'anrisstext';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "fieldDate", {
        get: function () {
            return 'sortierungsdatum';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "fieldEditDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "fieldCategory", {
        get: function () {
            return 'RUBKategorien';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "urlWeb", {
        get: function () {
            return 'aktuelles';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewsService.prototype, "urlList", {
        get: function () {
            return 'seiten';
        },
        enumerable: true,
        configurable: true
    });
    NewsService.loadCategoryIcon = function (field, term) {
        if (!term)
            return Promise.resolve(null);
        var svc = TermNaviService.start(field.get_termSetId().toString());
        return svc.loadTermCustomPropertyDescByTermId(term.get_termGuid().toString(), 'SVG');
    };
    NewsService.prototype.loadLastestNewsOfCategory = function (category) {
        var _this = this;
        return CacheLayer.simpleLoad(function () {
            return TaxonomyHelper.getChildrenWssIdsByTermItem(category).then(function (subCategoryIds) {
                if (subCategoryIds.length == 0) {
                    return undefined;
                }
                return _this.loadItemsByQuery("<Query>" +
                    "<Where>" +
                    ("<In><FieldRef LookupId='True' Name='" + _this.fieldCategory + "'/><Values>" + subCategoryIds.map(function (id) { return "<Value Type='Integer'>" + id + "</Value>"; }) + "</Values></In>") +
                    "</Where>" +
                    ("<OrderBy><FieldRef Name=\"" + _this.fieldDate + "\" Ascending=\"FALSE\"/></OrderBy>") +
                    "</Query>" +
                    "<RowLimit>1</RowLimit>").then(function (items) {
                    if (items.length > 0) {
                        return items[0];
                    }
                    return undefined;
                });
            });
        }, "loadLastestNewsOfCategory-" + category.id);
    };
    NewsService.prototype.finalizeItem = function (item, spItem, categoryField, list, web, site) {
        var category = TaxonomyHelper.getTermFieldValues(spItem.get_item(this.fieldCategory))[0];
        return NewsService.loadCategoryIcon(categoryField, category).then(function (icon) {
            item.icon = icon;
            item.author = spItem.get_item('Author') && spItem.get_item('Author').get_lookupValue();
            item.header = category && category.get_label();
            var image = NewsService.parseImage(spItem.get_item(NewsService.fieldImage));
            item.imageUrl = image.url;
            item.imageAlt = image.alt;
            return item;
        });
    };
    NewsService.prototype.finalizeItems = function (items, list, web, site) {
        return Promise.resolve(items);
    };
    NewsService.prototype.loadNews = function (rowLimit, publishedVersionsOnly) {
        var _this = this;
        if (rowLimit === void 0) { rowLimit = 6; }
        if (publishedVersionsOnly === void 0) { publishedVersionsOnly = true; }
        return CacheLayer.simpleLoad(function () {
            return new Promise(function (resolve, reject) {
                Helper.context()
                    .then(function () {
                    var filterByVersion = function (where) {
                        if (publishedVersionsOnly) {
                            where = "<And>" + where + "<Geq><FieldRef Name='_UIVersionString'/><Value Type='Text'>1.0</Value></Geq>" + "</And>";
                        }
                        return where;
                    };
                    var where = "<And><And>" +
                        ("<Eq><FieldRef Name='" + NewsService.fieldTopNews + "'/><Value Type='Boolean'>1</Value></Eq>") +
                        ("<IsNotNull><FieldRef Name='" + _this.fieldTeaser + "'></FieldRef></IsNotNull>") +
                        "</And>" +
                        ("<IsNotNull><FieldRef Name='" + NewsService.fieldImage + "'></FieldRef></IsNotNull>") +
                        "</And>";
                    return _this.loadItemsByQuery("<Query><Where>" +
                        filterByVersion(where) +
                        ("</Where><OrderBy><FieldRef Name=\"" + _this.fieldDate + "\" Ascending=\"FALSE\"/></OrderBy></Query><RowLimit>1</RowLimit>")).then(function (topItems) {
                        var where = "<Eq><FieldRef Name='ContentType'/><Value Type='Computed'>Aktuelles</Value></Eq>";
                        var result = [];
                        if (topItems.length > 0) {
                            result.push.apply(result, topItems);
                            where = "<And><Neq><FieldRef Name='ID'/><Value Type='Number'>" + topItems[0].id + "</Value></Neq>" + where + "</And>";
                        }
                        else {
                            rowLimit++;
                        }
                        return _this.loadItemsByQuery("<Query><Where>" + filterByVersion(where) + "</Where><OrderBy><FieldRef Name=\"" + _this.fieldDate + "\" Ascending=\"FALSE\"/></OrderBy></Query><RowLimit>" + rowLimit + "</RowLimit>").then(function (items) {
                            result.push.apply(result, items);
                            resolve(result);
                        });
                    });
                })
                    .catch(reject);
            });
        }, "loadNews-" + rowLimit + "-" + publishedVersionsOnly);
    };
    NewsService.fieldImage = 'PublishingPageImage';
    NewsService.fieldTopNews = 'TopNews';
    NewsService.parseImage = function (value) {
        if (!value)
            return { url: null, alt: null };
        if (value.startsWith('<') && value.endsWith('>')) {
            var div = document.createElement('div');
            div.innerHTML = value;
            var img = div.firstChild;
            return { url: img.src, alt: img.alt };
        }
        return { url: value, alt: '' };
    };
    return NewsService;
}(BaseService));
export { NewsService };
